import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { HexonProvider } from "../../providers/hexon/hexon";
import { IRemark } from "../../models/remark";

@Component({
  selector: "page-comments",
  templateUrl: "comments.html",
})
export class CommentsPage {
  public remark = "";

  private isNew: boolean;

  constructor(public navCtrl: NavController, private hexon: HexonProvider) {
    (async () => {
      const response = await hexon
        .getRemark()
        .first()
        .toPromise();
      const results = response.data[0].results;
      this.isNew = !results[0] || !results[0].remark || !results[0].remark.length;
      this.remark = this.isNew ? "" : results[0].remark[0].translation;
    })();
  }

  public changeText() {
    const data = {
      remark: [
        {
          translation: this.remark,
          language: "nl_NL",
        },
      ],
    } as IRemark;
    this.hexon
      .setRemark(data, this.isNew)
      .first()
      .toPromise();
    this.navCtrl.pop();
  }

  public cancel() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/comments/comments.ts